const DateOldest = (a, b) => {
    return (a.spin.dateCreatedInMilliseconds - b.spin.dateCreatedInMilliseconds);
}

export default DateOldest;